module.exports = __webpack_public_path__ + "img/img15.7a45c4d5.jpeg";